// src/icon-system/runtime/ikonBayragi.ts — İKON MOTORU BAYRAĞI (Faz C / dalga 1)
//
// Motor ikonları VARSAYILAN KAPALI. Kapalıyken ürün piksel-birebir ESKİ ikonları
// çizer (GÖZ referansları değişmez); açıkken `generated/*` (IconFrame) çizilir.
// Owner canlıda önizler: adrese `?ikon=on` ekler (geri alma: `?ikon=off`).
//
// Çözüm sırası (emsal: `myclipsv3/services/featureFlags.ts` ve
// `FeedContainerV3` `mylasa.ff.feedmode`):
//   0. URL `?ikon=on` | `?ikon=off`   → bu sayfa yüklemesinde kazanır; KAYITLI
//                                       tercihi de üzerine yazar (aşağıya bak)
//   1. localStorage `mylasa.ff.ikon`  → 'on' | 'off'  (UI Anayasası K9: `mylasa.*` uzayı)
//   2. env `REACT_APP_FF_IKON_MOTORU` → 'on'
//   3. varsayılan → off
// Her çağrıda okunur (bellek yok): test/önizleme toggle'ı yeniden derleme
// istemez; maliyet bir `getItem`. try/catch: özel pencere / erişim yasağı →
// kapalı (güvenli yön = eski ikon).
//
// ── KALICILIK — "oturumluk" DEĞİL ────────────────────────────────────────────
// `localStorage` tarayıcı kapanıp açılınca da DURUR (sessionStorage değil).
// Yani `?ikon=on` bir kez açıldığında o tarayıcıda kalıcı bir TERCİH bırakır.
// Bu bilinçli: owner yüzeyler arasında dolaşırken (profil → MyClips → harita)
// gezinmelerin çoğu sorgu dizesini taşımaz. Geri alma yolu bu yüzden
// parametrenin kendisidir ve kayıtlı tercihi EZER: `?ikon=off` hem bu sayfada
// kapatır hem kaydı `off` yapar → sonraki yenileme ve gezinmelerde de kapalı.
// Parametresiz ve kaydı olmayan kullanıcıda varsayılan KAPALI kalır.
//
// ── NEDEN URL PARAMETRESİ (2026-09-11) ───────────────────────────────────────
// Önizleme önce YALNIZ ayrı bir Hosting kanalıyla verilmeye çalışıldı ve o yol
// GİRİŞTE tıkandı.
//
// GÖZLENEN (kanıtı var): kanal adresinde giriş `auth/internal-error` ile
// düşüyor; tarayıcı konsolunda `appCheck/recaptcha-error` +
// `[APPCHECK] token warmup failed`. Ayrıca ölçüldü: `identitytoolkit` servis
// düzeyinde App Check **ENFORCED** (Firebase App Check API'sinden okundu) →
// jeton üretemeyen istemci giriş yapamaz. Ve Firebase Auth `authorizedDomains`
// listesinde kanal adresi **VAR** (deploy eylemi ekliyor) → eksik olan Auth
// tarafı değil.
//
// ⊘ DOĞRULANAMADI: *"kanal alan adı reCAPTCHA anahtarının izinli listesinde
// yok"* — bu **olası neden**, kanıtlanmış neden DEĞİL. İzinli alan listesi
// okunamadı (`recaptchaenterprise.keys.list` → 403; yönetim erişimi yok) ve
// başka bir kaynaktan da teyit edilmedi. **403 almak, listenin içeriği
// hakkında hüküm vermez.** (Kanon: gözlemi teşhis diye yazma.)
//
// Sebep ne olursa olsun SONUÇ ölçülmüştür: ayrı kanal, giriş gerektiren
// yüzeyler için kullanılamıyor. Bu parametre o tıkanıklığı, App Check'in
// halihazırda çalıştığı alan adının (canlı site) üstünde OPT-IN bir kapı
// açarak aşar.
//
// ⚠ GÜVENLİK: parametre YALNIZ ikon seçimini değiştirir. App Check, reCAPTCHA
// ve Auth kontrollerinin hiçbirine dokunmaz, atlatmaz, devre dışı bırakmaz;
// normal giriş akışı aynen korunur. Bu dosya kimlik doğrulama yolundaki
// hiçbir modülü import etmez (tek bağımlılığı `window.location` ve
// `window.localStorage`).
// ⚠ VARSAYILANI DEĞİŞTİRMEZ: parametre yoksa çözüm sırası eskisiyle birebir
// aynıdır — `ikonBayragiUrlSozlesmesi` testi bunu mutasyonla ölçer.
export const IKON_BAYRAK_ANAHTARI = "mylasa.ff.ikon";
export const IKON_BAYRAK_ENV = "REACT_APP_FF_IKON_MOTORU";
export const IKON_BAYRAK_URL_PARAM = "ikon";

// ══════════════════════════════════════════════════════════════════════════
// KİLİT — `REACT_APP_FF_IKON_KILIT=on` (2026-09-27, owner geri dönüş kararı)
// ══════════════════════════════════════════════════════════════════════════
// Owner canlıda yeni ikonları beğenmedi: "eski ikon görünümüne geri dön; daha önce
// `ikon=on` tercihi KAYDEDİLMİŞ tarayıcılarda da eski ikonlar görünsün".
// Yalnız env satırını kaldırmak bunu SAĞLAMAZ: çözüm sırası URL > localStorage > env,
// yani `mylasa.ff.ikon=on` kaydı olan tarayıcı motoru açık tutar (önizleme günlerinden
// kalan kayıtlar dâhil). Bu kilit, basamakların ÖNÜNDE durur:
//   · kilit AÇIKKEN `ikonMotoruAcikMi()` her koşulda false (URL `?ikon=on` dâhil),
//   · kayıtlı `mylasa.ff.ikon*` anahtarları SİLİNİR (kilit kalkınca bayat "on"
//     kendiliğinden geri gelmesin — o gün karar yeniden ve açıkça verilir),
//   · URL parametresi localStorage'a YAZILMAZ.
// Kilit bir "off" değeri değil, ayrı bir anahtardır: `REACT_APP_FF_IKON_MOTORU`'yu
// olduğu gibi bırakır (motor kaynakları korunur; yeni tasarım turu kilidi kaldırıp
// aynı bayraklarla devam eder). Yalnız derleme zamanı env'den okunur; istemci
// tarafında hiçbir yoldan açılıp kapatılamaz.
export const IKON_KILIT_ENV = "REACT_APP_FF_IKON_KILIT";
const IKON_DEPO_ANAHTARLARI = ["mylasa.ff.ikon", "mylasa.ff.ikon.kapsam", "mylasa.ff.ikon.aday"];

/** Kilit açık mı? (yalnız derleme-zamanı env; istemciden değiştirilemez) */
export function ikonKilitliMi(): boolean {
  try {
    return String(process.env[IKON_KILIT_ENV] || "").toLowerCase() === "on";
  } catch {
    return false;
  }
}

/** Kilit altında kayıtlı tercihleri siler (her çağrıda ucuz; başarısızlık sessiz — karar zaten false). */
function kilitTemizle(): void {
  if (typeof window === "undefined") return;
  try {
    for (const k of IKON_DEPO_ANAHTARLARI) window.localStorage?.removeItem(k);
  } catch {
    /* depolama yok → silinecek kayıt da yok */
  }
}

/**
 * URL parametresinin bu sayfa yüklemesindeki değeri. `null` = parametre yok
 * (ya da tanınmayan değer) → karar aşağıdaki basamaklara düşer, yani davranış
 * eskisiyle AYNI.
 */
let urlDegeri: "on" | "off" | null = null;

/**
 * `?ikon=on` / `?ikon=off` okunur ve localStorage'a YAZILIR.
 *
 * Yazma bir kolaylık değil, gerekliliktir: owner önizlemede yüzeyler arasında
 * dolaşır (profil → MyClips → harita) ve bu gezinmelerin çoğu adres
 * çubuğundaki sorgu dizesini taşımaz. localStorage'a yazmak seçimi oturum
 * boyunca taşır. Yazma başarısız olursa (özel pencere, depolama yasağı)
 * `urlDegeri` yine de bu sayfa yüklemesinde kazanır — yani parametre en
 * azından bulunduğu sayfada çalışır.
 *
 * Dışa açık, çünkü modül-yükleme yan etkisi testte tekrarlanamaz: süitler
 * `window.history.replaceState` ile adresi değiştirip bunu yeniden çağırır.
 */
export function ikonBayraginiUrldenTazele(): void {
  if (typeof window === "undefined") return;
  let ham: string | null = null;
  try {
    ham = new URLSearchParams(window.location.search).get(IKON_BAYRAK_URL_PARAM);
  } catch {
    return; /* ayrıştırılamayan adres → karar aşağıdaki basamaklara düşer */
  }
  if (ham !== "on" && ham !== "off") return;
  if (ikonKilitliMi()) {
    kilitTemizle(); // kilit: parametre ne okunur ne yazılır
    return;
  }
  urlDegeri = ham;
  try {
    window.localStorage?.setItem(IKON_BAYRAK_ANAHTARI, ham);
  } catch {
    /* depolama yok → seçim yalnız bu sayfa yüklemesinde geçerli */
  }
}

// Modül yüklenince bir kez: uygulama hiçbir şey çağırmadan karar hazır olsun.
ikonBayraginiUrldenTazele();
// KİLİT altında kayıtlı tercih, hiçbir ikon çizilmeden de silinir (ölçüldü 2026-09-27:
// giriş ekranında köprü yok → `ikonMotoruAcikMi` hiç çağrılmıyor → `mylasa.ff.ikon=on`
// oturum açılana kadar duruyordu; görünüm yine eskiydi ama kayıt bayat kalıyordu).
if (ikonKilitliMi()) kilitTemizle();

function yerelOku(): "on" | "off" | null {
  if (typeof window === "undefined") return null;
  try {
    const v = window.localStorage?.getItem(IKON_BAYRAK_ANAHTARI);
    if (v === "on" || v === "off") return v;
  } catch {
    /* erişim yok → karar env'e düşer */
  }
  return null;
}

function envOku(): boolean {
  try {
    return String(process.env[IKON_BAYRAK_ENV] || "").toLowerCase() === "on";
  } catch {
    return false;
  }
}

/** Motor ikonları çizilsin mi? (URL > localStorage > env > off) */
export function ikonMotoruAcikMi(): boolean {
  if (ikonKilitliMi()) {
    kilitTemizle(); // kayıtlı "on" bayatlamasın; karar her koşulda KAPALI
    return false;
  }
  if (urlDegeri !== null) return urlDegeri === "on";
  const yerel = yerelOku();
  if (yerel !== null) return yerel === "on";
  return envOku();
}

// ══════════════════════════════════════════════════════════════════════════
// ADAY ÖNİZLEME BAYRAĞI — `?ikonAday=on` (2026-09-21)
// ══════════════════════════════════════════════════════════════════════════
// Owner: *"Üretilen adaylar gerçek ürün yüzeyinde gösterilsin; mevcut insan
// çizimi REPOST bu kanıtın yerine geçmez."* Bu bayrak, kaydında `adayAilesi`
// olan özelliklerde ÜRETİLEN adayı çizdirir. Üç şey KASTEN böyle:
//   1. AYRI ANAHTAR: motor bayrağı (`mylasa.ff.ikon`) bunu AÇMAZ — owner
//      onaylı motor ikonlarını, onaysız adayları görmeden inceleyebilmeli.
//   2. BAĞIMLI: motor kapalıyken `OzellikIkonu` zaten `eski` görünümü çizer,
//      yani bu bayrak tek başına ürünü DEĞİŞTİREMEZ (varsayılan birebir).
//   3. AYNI ÇÖZÜM SIRASI: URL > localStorage > env > off (ikinci bir kip yok).
export const IKON_ADAY_BAYRAK_ANAHTARI = "mylasa.ff.ikon.aday";
export const IKON_ADAY_BAYRAK_ENV = "REACT_APP_FF_IKON_ADAY";
export const IKON_ADAY_URL_PARAM = "ikonAday";

let adayUrlDegeri: "on" | "off" | null = null;

/** `?ikonAday=on|off` okunur ve localStorage'a yazılır (motor bayrağının eşi). */
export function ikonAdayBayraginiUrldenTazele(): void {
  if (typeof window === "undefined") return;
  let ham: string | null = null;
  try {
    ham = new URLSearchParams(window.location.search).get(IKON_ADAY_URL_PARAM);
  } catch {
    return;
  }
  if (ham !== "on" && ham !== "off") return;
  adayUrlDegeri = ham;
  try {
    window.localStorage?.setItem(IKON_ADAY_BAYRAK_ANAHTARI, ham);
  } catch {
    /* depolama yok → seçim yalnız bu sayfa yüklemesinde geçerli */
  }
}

ikonAdayBayraginiUrldenTazele();

// ══════════════════════════════════════════════════════════════════════════
// YAYIN KAPSAMI — `?ikonKapsam=onayli|tam` (2026-09-25)
// ══════════════════════════════════════════════════════════════════════════
// ── NİYE VAR (koddan ölçülen boşluk) ─────────────────────────────────────
// Motor bayrağı TEK BİR BOOLE'dür (`ikonMotoruAcikMi`, yukarıda) ve köprü
// (`IkonKoprusu.tsx`) o boole'a bakıp ailenin ONAY DURUMUNU HİÇ SORMADAN
// motoru çizer. Onay durumu iki yerde yazılı — `generated/index.ts`
// `TASLAK_AILELER` / `IKON_BILGISI[*].taslak` (derleyici üretir) ve
// `ozellikKaydi.ts` `onayBekliyor` (kayıt) — ama ikisini de çalışma
// zamanında HİÇBİR karar okumuyordu (ölçüldü: `git grep TASLAK_AILELER`
// yalnız derleyiciye ve testlere çarpıyor). Sonuç: bayrak açılınca taslak
// aileler (`IkonTaslak` kesikli çerçevesiyle) da kullanıcıya gider; owner
// o çerçeveyi nihai ikonun parçası saymadığı için (OWNER_GORSEL_OKUMALARI
// 2026-09-21) bayrak KİMSEYE açılamıyor — yani iki taslak aile, 77 onaylı
// aileyi de bekletiyordu. Granülerlik aile başına DEĞİL, tümü-ya-hiçti.
//
// ── NE YAPAR ─────────────────────────────────────────────────────────────
//   onayli (VARSAYILAN) → motor yalnız ONAYLI (taslak olmayan) aileleri
//                         çizer; taslak ailenin çağrı yeri `eski`yi çizer
//                         (bayrak kapalı koluyla DOM-birebir).
//   tam                 → bugünkü davranış: taslaklar IkonTaslak çerçevesiyle
//                         görünür (owner önizlemesi / kabul turu).
// Varsayılanın `onayli` olmasının sebebi güvenli yön: bir taslağın
// kullanıcıya gitmesi ancak AÇIK bir eylemle (`?ikonKapsam=tam`) mümkün
// olur; unutulan bir env değişkeni taslak sızdırmaz.
//
// ── NE YAPMAZ ────────────────────────────────────────────────────────────
// · Motor bayrağı KAPALIYKEN hiçbir etkisi yoktur (köprü bu fonksiyonu
//   çağırmadan `eski`ye döner) → varsayılan ürün birebir.
// · Onay kararı vermez; kararı `yayinKapisi.motorYayinaUygun` verir (aile `taslak`
//   + varyant `onayBekleyenVaryantlar`, 2026-09-26). Bu dosya yalnız kapsamı söyler.
//   Bir aileyi "onaylı" yapan şey manifestte `taslak`ın kalkmasıdır
//   (owner görsel kabulü) — bu dosya değil.
// · Aday önizleme bayrağını (`?ikonAday`) EZMEZ; aday aileler taslak olduğu
//   için `onayli` kapsamda onlar da `eski`ye düşer. Aday görmek için
//   `?ikon=on&ikonKapsam=tam&ikonAday=on`.
export const IKON_KAPSAM_ANAHTARI = "mylasa.ff.ikon.kapsam";
export const IKON_KAPSAM_ENV = "REACT_APP_FF_IKON_KAPSAM";
export const IKON_KAPSAM_URL_PARAM = "ikonKapsam";
export type IkonYayinKapsami = "onayli" | "tam";
export const IKON_KAPSAM_VARSAYILAN: IkonYayinKapsami = "onayli";

let kapsamUrlDegeri: IkonYayinKapsami | null = null;

function kapsamDegeriMi(v: unknown): v is IkonYayinKapsami {
  return v === "onayli" || v === "tam";
}

/** `?ikonKapsam=onayli|tam` okunur ve localStorage'a yazılır (motor bayrağının eşi). */
export function ikonKapsamBayraginiUrldenTazele(): void {
  if (typeof window === "undefined") return;
  let ham: string | null = null;
  try {
    ham = new URLSearchParams(window.location.search).get(IKON_KAPSAM_URL_PARAM);
  } catch {
    return;
  }
  if (!kapsamDegeriMi(ham)) return;
  kapsamUrlDegeri = ham;
  try {
    window.localStorage?.setItem(IKON_KAPSAM_ANAHTARI, ham);
  } catch {
    /* depolama yok → seçim yalnız bu sayfa yüklemesinde geçerli */
  }
}

ikonKapsamBayraginiUrldenTazele();

/**
 * Yayın kapsamı (URL > localStorage > env > `onayli`). Yalnız motor bayrağı
 * AÇIKKEN anlamlıdır; köprü onu ancak o zaman sorar.
 */
export function ikonYayinKapsami(): IkonYayinKapsami {
  if (kapsamUrlDegeri !== null) return kapsamUrlDegeri;
  if (typeof window !== "undefined") {
    try {
      const v = window.localStorage?.getItem(IKON_KAPSAM_ANAHTARI);
      if (kapsamDegeriMi(v)) return v;
    } catch {
      /* erişim yok → env'e düş */
    }
  }
  try {
    const e = String(process.env[IKON_KAPSAM_ENV] || "").toLowerCase();
    if (kapsamDegeriMi(e)) return e;
  } catch {
    /* env yok */
  }
  return IKON_KAPSAM_VARSAYILAN;
}

/** Üretilen aday ailesi çizilsin mi? (URL > localStorage > env > off) */
export function ikonAdayOnizlemeAcikMi(): boolean {
  if (adayUrlDegeri !== null) return adayUrlDegeri === "on";
  if (typeof window !== "undefined") {
    try {
      const v = window.localStorage?.getItem(IKON_ADAY_BAYRAK_ANAHTARI);
      if (v === "on" || v === "off") return v === "on";
    } catch {
      /* erişim yok → env'e düş */
    }
  }
  try {
    return String(process.env[IKON_ADAY_BAYRAK_ENV] || "").toLowerCase() === "on";
  } catch {
    return false;
  }
}
